import {
  ChargeItemDefinitionCode,
  createFhirDateTime,
} from '@quromedical/fhir-common';
import type { CreateChargeItemDefinition } from '@quromedical/models';

import type { ChargeItemDefinition as FormData } from './ChargeItemDefinitionForm';

export const mapFormDataToChargeItemRequest = (
  data: FormData,
): CreateChargeItemDefinition => {
  return {
    code: ChargeItemDefinitionCode.ClaimLine,
    date: createFhirDateTime(new Date()),
    title: data.title,
    description: data.description,
    chargeLines: data.chargeLines.map((line) => ({
      code: line.chargeCode,
      type: 'base',
      amount: {
        currency: line.currency,
        factor: line.amountFactor,
        value: line.amount,
      },
      applicability: {
        administratorCode:
          line.type === 'administrator' ? line.identifierCode : undefined,
        schemeCode: line.type === 'scheme' ? line.identifierCode : undefined,
        description: line.identifierDisplay,
      },
    })),
    effectivePeriod: {
      start: data.effectivePeriodStart,
      end: data.effectivePeriodEnd,
    },
  };
};
